var path = 'directives/loadingIndicator.html';
var html = "<div class=loader data-ng-class=\"'loader-' + color\"> <div class=\"loader-bounce loader-bounce1\"></div> <div class=\"loader-bounce loader-bounce2\"></div> <div class=\"loader-bounce loader-bounce3\"></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/directives/loadingIndicator.html
// module id = UC/o
// module chunks = 1